import PartTableView from './PartTableView'

export default PartTableView
